import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import {
  CForm,
  CFormLabel,
  CFormInput,
  CButton,
  CFormCheck
} from '@coreui/react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import axios from "axios";
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import AxiosInstance from 'src/components/Axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import { Alert } from 'react-bootstrap';
import NewsMedia from 'src/components/news/NewsMedia';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PageInfoList from 'src/components/page-info/PageInfoList';
import MediaFrom from 'src/components/media/MediaFrom';
import LangugesPanel from './LangugesPanel';
import Select from 'react-select';
import { reactSelectStyles, reactSelectStylesType1 } from '../../styles/reactSelectStyles';
import { formatShortName } from 'src/store';

const urlRouter = '/post';
const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;
const urlApi = '/posts';
export async function LoaderBlogUpdate({ params }) {
  if (Object.keys(params).length != 0 && params.id != undefined) {
    let res = await AxiosInstance.get(`${urlApi}/${params.id}`).then((response) => {
      response['type'] = (params.type != undefined) ? params.type : "post";
      // console.log("posts/id/ get response", response);
      return response;
    });
    return res;
  };

  return { type: (params.type != undefined) ? params.type : 'post', data: undefined };
};


const formReducer = (state, event) => {
  return {
    ...state,
    [event.target.name]: event.target.value
  }
}

const blogForm = ({ user_data }) => {
  if (!Permissions(user_data, 'Blog', 'VIEW_BLOG')) {
    return <PermissionsNoPage />;
  }
  const { data, type } = useLoaderData();
  const [user, setUser] = useState(false);
  const [owners, setOwners] = useState((data?.owners != undefined) ? data.owners.map(owner => { return { label: getUserName(owner), value: owner.id } }) : []);
  const [ownersOptions, setOwnersOptions] = useState([]);

  const [name, setName] = useState((data?.name != undefined) ? formatShortName(data.name) : '');
  const [pageType, setPageType] = useState((type != undefined) ? type : 'post');

  const [dateEntered, setDateEntered] = useState((data != undefined && data.dateEntered != undefined) ? new Date(data.dateEntered).toISOString() : new Date().toISOString());
  const [dateModified, setDateModified] = useState((data != undefined && data.dateModified != undefined) ? new Date(data.dateModified).toISOString() : new Date().toISOString());
  const [currentMedia, setCurrentMedia] = useState((data != undefined) && data.mainMedia);
  const [language, setLaguage] = useState((data != undefined) ? data.language?.key : 'ua');
  const [pinnet, setPinnet] = useState((data?.pinnet != undefined) ? data.pinnet : false);
  const [fontSize, setFontSize] = useState('50');
  const [unitOfMeasurement, setUnitOfMeasurment] = useState('px');
  const [lineHeight, setLineHeight] = useState('60');
  const navigate = useNavigate();
  
  const popup = MyToastify();
  const editorRef = useRef(null);

  //значеня для селекту одиниць виміру
  const unitsOfMeasurement = [
    { value: 'px', label: 'px' },
    { value: 'rem', label: 'rem' },
    { value: 'em', label: 'em' },
  ];

  const handleChangeUnitsOfMeasurment = (selectedOption) => {
    setUnitOfMeasurment(selectedOption.value);
  };

  useEffect(() => {
    const user = localStorage.getItem('user_data');
    if (user !== null && user !== '') {
      setUser(JSON.parse(user));
    }
  }, [])

  useEffect(() => {
    if (data?.owners?.length === 0 || data?.owners === undefined) {
      setOwners([{ label: getUserName(user), value: user.id }])
    }
  }, [user])

  function getUserName(data) {
    if (data?.firstName?.length > 0 || data?.firstName?.length > 0) {
      return `${data.firstName || ""} ${data.lastName || ""}`;
    }
    if (data?.first_name?.length > 0 || data?.last_name?.length > 0) {
      return `${data.first_name || ""} ${data.last_name || ""}`;
    }
    if (data?.username?.length > 0) {
      return data.username;
    }
    if (data?.email > 0) {
      return data.username;
    }
    if (data.id) {
      return data.id
    }
    return "";
  }

  useEffect(() => {
    AxiosInstance.get('/users?pagination=false').then((response) => {
      const data = response.data['hydra:member'];
      // console.log(data);
      const ownerOptions = data.map(owner => {
        return { label: getUserName(owner), value: owner.id }
      })
      setOwnersOptions(ownerOptions);

    }).catch((err) => console.log(err));
  }, [])

  useEffect(() => {
    // setMyData(data)
    setPageType(data?.type || type)
    setDateEntered((data && data.dateEntered) ? new Date(data.dateEntered).toISOString() : new Date().toISOString())
    setDateModified((data && data.dateModified) ? new Date(data.dateModified).toISOString() : new Date().toISOString())

    setCurrentMedia(data?.mainMedia)
    setName(data?.name ? formatShortName(data.name) : '');
  }, [data]);

  useEffect(() => {
    if (data?.name !== undefined) {
      const regex = /font-size:([\d\.]+)([a-zA-Z%]+)/;
      const match = data.name.match(regex);
      if (match) {
        setFontSize(match[1]);
        setUnitOfMeasurment(match[2]);
      }

      const lhRegex = /line-height:([\d\.]+)([a-zA-Z%]*)/;
      const lhMatch = data.name.match(lhRegex);
      if (lhMatch) {
        setLineHeight(lhMatch[1]);
      }
    }
  }, [data?.name]);

  const handleSubmit = event => {
    event.preventDefault();
    if (editorRef.current) {
      // console.log(editorRef.current.getContent());
      const article = {
        name: `<h1 style='font-size:${fontSize}${unitOfMeasurement}; line-height:${lineHeight}${unitOfMeasurement}'>${name}</h1>`,
        dateEntered: dateEntered,
        dateModified: dateModified,
        type: pageType,
        pinnet: pinnet,
        content: editorRef.current.getContent(),
        owners: owners.map(owner => `/api/users/${owner?.value}`),
      };      
      if (data != undefined) {
        article.language = data.language ? `/api/languages/${data.language.id}` : `/api/languages/1`;
        const response = AxiosInstance.put('/posts/' + data.id, article).then((response) => {
          popup.toastifySuccess('Пост оновлено');
          if (type == undefined || type == 'page' || type == '')
            return navigate(`${urlRouter}/update/${response.data.id}`);
          else
            return navigate(`/post/${type}/${response.data.id}`);
        });
      } else {
        article.language = `/api/languages/1`;
        const response = AxiosInstance.post('/posts', article).then((response) => {
          popup.toastifySuccess('Пост cтворено');
          if (type == undefined || type == 'post' || type == '')
            return navigate(`${urlRouter}/update/${response.data.id}`);
          else
            return navigate(`/post/${type}/${response.data.id}`);
        });
      }
    }
  }

  const datePicker = (value) => {
    return value.toISOString();
  }

  function changeMedia() {
    if (currentMedia === data?.mainMedia) {
      popup.toastifyWarning('Не завантажено нового зображення');
    }
    else {
      if (currentMedia && data?.mainMedia !== undefined) {
        const oldId = data.mainMedia.id;
        AxiosInstance.put(`/posts/${data.id}`, { mainMedia: currentMedia['@id'] }).then(() => {
          popup.toastifySuccess('Зображення оновлено');
          AxiosInstance.delete(`/media_objects/${oldId}`); // видалення старої прив'язки
        })
      } else if (currentMedia && data?.mainMedia === undefined) {
        AxiosInstance.put(`/posts/${data.id}`, { mainMedia: currentMedia['@id'] }).then(() => {
          popup.toastifySuccess('Зображення додано');
        })
      }
      else {
        AxiosInstance.put(`/posts/${data.id}`, { mainMedia: currentMedia['@id'] }).then(() => {
          popup.toastifySuccess('Зображення оновлено');
        })
      }
    }
  }
  // console.log('data', data)
  // console.log('type', type)
  return (
    <>
      <div className='col d-flex justify-content-end'>
        {data !== undefined &&
          <LangugesPanel data={data}
            // setMyData={setMyData}
            setLaguage={setLaguage}
            language={language} />}
      </div>
      {data !== undefined &&
        <div className='mb-3'>
          <MediaFrom type="materials" setNewMedia={setCurrentMedia} toastifySuccess={popup.toastifySuccess} />
          {currentMedia && <>
            <img className='object-img mt-3' width={300} height={300} src={process.env.REACT_APP_SERVER_URL + currentMedia.contentUrl} />
            {currentMedia?.id !== data?.mainMedia?.id && <CButton type="submit" onClick={changeMedia} className="my-3" color="success">Зберегти Зображення</CButton>} </>

          }
        </div>}
      <CForm onSubmit={handleSubmit}>
        {/* <div className="mb-3 info-col">
          <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} />
        </div> */}
        
        <div className='row'>
          <div className='col info-col'>
            <div className="mb-3">
              <CFormLabel htmlFor="nameWithStyle">Назва</CFormLabel>
              <CFormInput type="text" id="nameWithStyle" value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" />
            </div>
          </div>
          <div className='col info-col'>
            <div className="mb-3">
              <CFormLabel htmlFor="fontSize">Розмір шрифта</CFormLabel>
              <CFormInput type="text" id="fontSize" value={fontSize} onChange={(e) => setFontSize(e.target.value)} autoComplete="off" />
            </div>
          </div>
          <div className='col info-col'>
            <div className="mb-3">
              <CFormLabel htmlFor="lineHeight">Висота лінії</CFormLabel>
              <CFormInput type="text" id="lineHeight" value={lineHeight} onChange={(e) => setLineHeight(e.target.value)} autoComplete="off" />
            </div>
          </div>
          <div className='col'>
            <div className="mb-3 react-select-wrapper">
              <CFormLabel className='label-base-view' htmlFor="unitOfMeasurement">Одиниці виміру</CFormLabel>
              <Select
                options={unitsOfMeasurement}
                value={unitsOfMeasurement.find((unit) => unit.value === unitOfMeasurement)}
                onChange={(value) => { handleChangeUnitsOfMeasurment(value) }}
                styles={reactSelectStyles}
              />
            </div>
          </div>
        </div>
        <div className="mb-3 info-col">
          <CFormLabel htmlFor="exampleFormControlInput1">Дата публікації</CFormLabel>
          <DatePicker
            className="form-control"
            dateFormat="yyyy-MM-dd"
            selected={new Date(dateEntered)}
            onChange={(date) => setDateEntered(datePicker(date))}
          />
        </div>
        <div className="mb-3 info-col">
          <CFormLabel htmlFor="exampleFormControlInput1">Дата модифікації</CFormLabel>
          <DatePicker
            className="form-control"
            dateFormat="yyyy-MM-dd"
            selected={new Date(dateModified)}
            onChange={(date) => setDateModified(datePicker(date))}
            disabled
          />
        </div>
        <div className="mb-3 react-select-wrapper">
          <CFormLabel className='label-base-view' htmlFor="exampleFormControlInput3">Користувач (Автори)</CFormLabel>
          <Select
            value={owners}
            isMulti
            name="colors"
            options={ownersOptions}
            className="basic-select"
            classNamePrefix="select"
            onChange={(owner) => {
              setOwners(owner);
            }}
            styles={reactSelectStyles}
          />
          {/* <CFormInput type="text" id="exampleFormControlInput3" value={user ? `${user?.first_name} ${user?.last_name}` : ''} disabled /> */}
        </div>
        <div className="mb-3">
          <CFormCheck id="exampleFormControlInput8" label="Закріплено" checked={pinnet} onChange={() => setPinnet(!pinnet)} />
        </div>
        <div className="mb-3 info-col">
          <CFormLabel htmlFor="exampleFormControlInput2">Тип</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput2" value={pageType} onChange={(e) => setPageType(e.target.value)} autoComplete="off" disabled={(type == undefined || type == 'page') ? false : true} />
        </div>
        <div className="mb-3">
          <Editor
            apiKey={apiKey}
            onInit={(evt, editor) => editorRef.current = editor}
            initialValue={(data != undefined) ? data.content : ''}
            init={{
              height: 500,
              menubar: 'edit view insert format',
              plugins: [
                'advlist', 'autolink',
                'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
                'insertdatetime', 'media', 'table', 'help', 'code'
              ],
              toolbar: 'undo redo | fontfamily fontsize | fontselect | bold italic backcolor | ' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist checklist outdent indent | removeformat | link media a11ycheck code table help',
              content_style: 'body { font-family:FixelDisplayRegular; font-size:14px }',
              font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Fixel Display Regular=fixelDisplayRegular; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
            }}
          />
        </div>
        <CButton type="submit" color="success">Зберегти</CButton>
      </CForm>
      {(data != undefined) &&
        <PageInfoList id={data.id} type="posts" />
      }
      <ToastContainer />
    </>
  );
};

export default blogForm;
